import React from 'react'
import { useNavigate } from 'react-router-dom'
import { ArrowLeft, FileText, UserCheck, GraduationCap, Speech, BookOpen, Search } from 'lucide-react'
import './JoinResearch.css'

const JoinResearch = () => {
  const navigate = useNavigate()

  return (
    <div className="join-research-page">
      <div className="container">
        {/* Header con botón de regreso */}
        <div className="page-header">
          <button className="back-button" onClick={() => navigate(-1)}>
            <ArrowLeft size={20} />
            Volver
          </button>
          <h1>Cómo ser Investigador</h1>
        </div>

        <div className="researcher-content">
          {/* Imagen ilustrativa */}
          <div className="researcher-image">
            <img
              src="https://res.cloudinary.com/dcm2dsjov/image/upload/v1766338468/WhatsApp_Image_2025-12-21_at_11.32.32_AM_kxzess.jpg"
              alt="Investigadores trabajando"
            />
          </div>

          <div className="researcher-info">
            <section className="info-block">
              <h2><UserCheck size={24} /> Requisitos Iniciales</h2>
              <p>Para postularte como investigador unitario, debes presentar la siguiente documentación:</p>
              <ul className="requirements-list">
                <li>
                  <FileText size={18} />
                  <span><strong>Curriculum:</strong> Hoja de vida actualizada.</span>
                </li>
                <li>
                  <GraduationCap size={18} />
                  <span><strong>Historial de Clases:</strong> Historial académico reciente.</span>
                </li>
                <li>
                  <FileText size={18} />
                  <span><strong>Forma 03:</strong> Documento oficial de matrícula.</span>
                </li>
              </ul>
            </section>

            <section className="info-block">
              <h2><Speech size={24} /> Procedimiento de Ingreso</h2>
              <p>El proceso de selección consta de una fase de evaluación personal y técnica:</p>
              <div className="procedure-card">
                <h3>Entrevista Inicial y Defensa</h3>
                <p>Serás sometido a una entrevista inicial donde deberás <strong>defender un tema de investigación</strong>, explicando el mismo ante el comité para demostrar tus capacidades analíticas y de oratoria.</p>
              </div>
            </section>

            <section className="info-block">
              <h2><BookOpen size={24} /> Requisitos de Permanencia</h2>
              <ul className="requirements-list">
                <li>
                  <Search size={18} />
                  <span>Consolidar una investigación o compendio de tema de preferencia.</span>
                </li>
                <li>
                  <Speech size={18} />
                  <span>Defender la investigación consolidada.</span>
                </li>
              </ul>
            </section>
          </div>
        </div>

        {/* Sección de contacto */}
        <div className="contact-section">
          <h3>¿Estás listo para el reto?</h3>
          <p>Envía tu documentación y agenda tu entrevista con nosotros:</p>
          <div className="contact-info">
            <div className="contact-item">
              <span className="contact-label">Teléfono / WhatsApp:</span>
              <span className="contact-value">+504 9777-3865</span>
            </div>
            <div className="contact-item">
              <span className="contact-label">Email:</span>
              <span className="contact-value">vtic.unahcortes@gmail.com</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default JoinResearch


